import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const inventoryApi = api
  .enhanceEndpoints({ addTagTypes: ["maintenances"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      deleteReason: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/maintenances/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["maintenances"],
      }),
      createMaintenance: builder.mutation({
        query: ({
          branchId,
          task,
          observation,
          days,
          startDate,
          endDate,
          inventoryItemIds,
          urgency,
          assignedId,
        }) => ({
          url: `branchs/${branchId}/maintenances`,
          method: RequestMethod.POST,
          body: camelToSnake({
            branchId,
            task,
            observation,
            days,
            startDate,
            endDate,
            inventoryItemIds,
            urgency,
            assignedId,
          }),
        }),
        invalidatesTags: ["maintenances"],
      }),
      updateMaintenance: builder.mutation({
        query: ({
          id,
          favorite,
          branchId,
          state,
          urgency,
          assignedId,
          date,
          inventoryItemIds,
          observation,
        }) => ({
          url: `branchs/${branchId}/maintenances/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            state,
            urgency,
            assignedId,
            observation,
            date,
            favorite,
            inventoryItemIds,
          }),
        }),
        invalidatesTags: ["maintenances"],
      }),
      maintenanceItems: builder.query({
        query: ({ branchId, inventoryItemId, maintenanceId }) => ({
          url: `branchs/${branchId}/maintenance-items`,
          method: RequestMethod.GET,
          params: camelToSnake({
            inventoryItemId,
            maintenanceId,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["maintenances"],
      }),
      maintenance: builder.query({
        query: ({
          branchId,
          search,
          page,
          pageSize,
          state,
          urgency,
          assignedId,
          startDate,
          endDate,
        }) => ({
          url: `branchs/${branchId}/maintenances`,
          method: RequestMethod.GET,
          params: camelToSnake({
            search,
            state,
            assignedId,
            urgency,
            startDate,
            endDate,
            page,
            pageSize,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response),
        providesTags: ["maintenances"],
      }),

      getMaintenanceById: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `/branchs/${branchId}/maintenances/${id}/edit`,
          method: RequestMethod.GET,
        }),
      }),
      changeMaintenanceStatus: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `/branchs/${branchId}/maintenances/change_status/${id}`,
          method: RequestMethod.PUT,
        }),
        invalidatesTags: ["maintenances"],
      }),
    }),
  });

export const {
  useMaintenanceQuery,
  useUpdateMaintenanceMutation,
  useCreateMaintenanceMutation,
  useMaintenanceItemsQuery,
  useGetMaintenanceByIdMutation,
  useChangeMaintenanceStatusMutation,
} = inventoryApi;
